import styled from 'styled-components'
import above from '@/utils/above'
import getColumnSize from '@/utils/getColumnSize'
import getTypeStyle from '@/utils/getTypeStyle'
import * as UI from '@/components/UI'

export const Section = styled.section`
  width: ${getColumnSize(12)};
  margin-bottom: 4rem;
  ${above('lg')`
    margin-bottom: 7.5rem;
    width: ${getColumnSize(6)};
  `}
  ${above('xg')`
    width: ${getColumnSize(5)};
  `}
`

export const Inner = styled.div`
  background: ${p => p.theme.colors.maastricht};
  color: ${p => p.theme.colors.white};
  margin: 0 -1rem;
  padding: 2.5rem 1rem 1.25rem;
  ${above('md')`
    padding: 2.5rem 2rem 1.5rem;
    margin: 0 -2rem;
  `}
  ${above('lg')`
    padding: 2.5rem 2.5rem 1.75rem;
    margin: 0;
    border-radius: 0.125rem;
  `}
`

export const TitleBar = styled.div`
  margin-bottom: 1.125rem;
  ${above('md')`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 3rem;
  `}
  a {
    padding: 1.25rem 0;
    ${above('md')`
      padding: inherit;
    `}
  }
`

export const Title = styled(UI.Subtitle)`
  font-family: ${p => p.theme.type.fonts.headline};
`

export const CardGrid = styled.div`
  margin: -0.75rem 0;
`

export const CardCell = styled.div`
  margin: 0.75rem 0;
`

export const CardWrapper = styled(UI.Link)`
  display: flex;
  border-radius: 0.125rem;
  position: relative;
  margin: -0.75rem;
  padding: 0.75rem;
  &:hover,
  &:focus,
  &:active {
    background: ${p => p.theme.colors.aqua};
    color: ${p => p.theme.colors.white};
    z-index: 1;
  }
`

export const CardImageWrapper = styled.div`
  width: 4.875rem;
  min-height: 4.875rem;
  border-radius: 0.125rem;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 2rem;
`

export const CardImage = styled(UI.Image)`
  display: block;
  object-fit: cover;
  object-position: center;
  min-height: 100%:
  max-height: 10rem;
  min-width: 100%;
  height: 100%;
  overflow: hidden;
`

export const CardMain = styled.div`
  max-width: 27.5rem;
`

export const CardTitle = styled(UI.BlogText)`
  font-family: ${p => p.theme.type.fonts.headline};
  display: block;
  padding-bottom: 0.75rem;
`

export const CardTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
`

export const CardTag = styled.li`
  display: flex;
  color: ${p => p.theme.colors.gray};
  text-transform: uppercase;
  font-weight: 500;
  ${getTypeStyle('label')};
  &:after {
    content: '•';
    margin: 0 0.5rem;
  }
  &:last-child {
    &:after {
      content: none;
    }
  }
  ${CardWrapper}:hover &,
  ${CardWrapper}:focus &,
  ${CardWrapper}:active & {
    color: currentColor;
    opacity: 0.8;
  }
`

export const NewsletterWrapper = styled.div`
  display: block;
  background: ${p => p.theme.colors.maastricht};
  color: ${p => p.theme.colors.white};
  margin: 0 -1rem;
  padding: 1.5rem 1rem 1rem;
  ${above('md')`
    padding: 1.5rem 2rem 1rem;
    margin: 0 -2rem;
  `}
  ${above('lg')`
    padding: 1.5rem 2.5rem 1rem;
    margin: 1.5rem 0 0;
    border-radius: 0.125rem;
  `}
  input {
    width: 100%;
  }
  label {
    font-family: ${p => p.theme.type.fonts.headline};
  }
`
